"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRIMARY_ATTRIBUTE_INDEX = exports.PARENT_ATTRIBUTE_INDEX = exports.STACK_BY_DIMENSION_INDEX = exports.VIEW_BY_DIMENSION_INDEX = void 0;
// (C) 2007-2019 GoodData Corporation
exports.VIEW_BY_DIMENSION_INDEX = 1;
exports.STACK_BY_DIMENSION_INDEX = 0;
exports.PARENT_ATTRIBUTE_INDEX = 0; // first attribute in 'View By' panel
exports.PRIMARY_ATTRIBUTE_INDEX = 1; // second attribute in 'View By' panel
//# sourceMappingURL=dimensions.js.map